// utility to log GQL errors
export var INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR';
export var logGQLErrors = function logGQLErrors(message, error) {
  // ignoring this as optional chaining has open issues with satisfying branch coverage: https://github.com/istanbuljs/istanbuljs/issues/516

  /* istanbul ignore next */
  if (error !== null && error !== void 0 && error.graphQLErrors && error.graphQLErrors.length !== 0) {
    var _error$graphQLErrors;

    (_error$graphQLErrors = error.graphQLErrors) === null || _error$graphQLErrors === void 0 ? void 0 : _error$graphQLErrors.forEach(function (err) {
      var _err$extensions;

      if ((err === null || err === void 0 ? void 0 : (_err$extensions = err.extensions) === null || _err$extensions === void 0 ? void 0 : _err$extensions.code) == INTERNAL_SERVER_ERROR) console.error("GQL error: ".concat(message, ": "), err.message);
    });
  } else {
    console.error("GQL error: ".concat(message, ": "), JSON.stringify(error === null || error === void 0 ? void 0 : error.message));
  }
};